import type { FC } from 'react'

import { LocalDateTime } from '@/components/LocalDateTime'

export type SmsType = { sender: string; message: string; sent: string; receiver: string }

export const SmsLogItem: FC<SmsType> = ({ sender, message, sent }) => (
  <div className="animate-fade-in mt-4 border-t border-solid border-gray-300 border-x-transparent border-b-transparent pt-4 first:border-t-transparent">
    <div className="text-xs md:text-sm">{sender}</div>
    <div className="text-xs text-gray-500 md:text-sm">
      <LocalDateTime date={sent} />
    </div>
    <div className="mt-1 whitespace-pre-wrap">{message}</div>
  </div>
)
